import Shortcode from "src/libs/useful/shortcode"
import AnonymUserStartLabel from "./AnonymUserStartLabel"
import { ITestProps } from "./SingleTest"

const Start = ({ item, ...props }: ITestProps) : JSX.Element => {

    return <div className="pe-matching-start mb-1" data-testid="test-start"> 
        <div className="pe-matchings-thumbnail-cont">
            <div 
                className="pe-matchings-thumbnail "
                style={{backgroundImage:`url(${item.thumbnail})`}}
            /> 
        </div>
        <div className="container">
            <Shortcode
                className={`pe-matchings-title title `} 
                content={ item.title }
                data-testid="test-start-title"
                style={props.titleStyle}
            />
            <Shortcode 
                className={"pe-matchings-description fs-3 letter-spacing-2 text-force-contrast" } 
                content={ item.post_content } 
                data-testid="test-start-content"
            />
        </div>
        <AnonymUserStartLabel item={item} />
    </div>
}

Start.propTypes = {}

export default Start